import { Instance } from 'mobx-state-tree';
import { RouteUnpublishedChangesDiscardedDtoModelBase } from './RouteUnpublishedChangesDiscardedDtoModel.base';

/* The TypeScript type of an instance of RouteUnpublishedChangesDiscardedDtoModel */
export interface RouteUnpublishedChangesDiscardedDtoModelType extends Instance<typeof RouteUnpublishedChangesDiscardedDtoModel.Type> {}

/* A graphql query fragment builders for RouteUnpublishedChangesDiscardedDtoModel */
export { selectFromRouteUnpublishedChangesDiscardedDto, routeUnpublishedChangesDiscardedDtoModelPrimitives, RouteUnpublishedChangesDiscardedDtoModelSelector } from './RouteUnpublishedChangesDiscardedDtoModel.base';

/**
 * RouteUnpublishedChangesDiscardedDtoModel
 */
export const RouteUnpublishedChangesDiscardedDtoModel = RouteUnpublishedChangesDiscardedDtoModelBase;
